var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fondo"},[_c('mensajeSistema'),_c('Principal'),_c('Portafolio'),_c('Contacto')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }